import { useEvent } from '@atlassian/jira-software-react-use-event/src/index.tsx';
import type { CardId } from '../../../model/types.tsx';
import { cardSingleSelect } from '../../actions/cards/selection/index.tsx';
import { useBacklogDispatch, useBacklogSelector } from '../../index.tsx';
import { getSelectedCards } from '../../selectors/cards/index.tsx';

export function useSelectSingleCard(): (cardId: CardId) => void {
	const selectedCards = useBacklogSelector(getSelectedCards);
	const dispatch = useBacklogDispatch();
	return useEvent((cardId: CardId) => {
		if (!selectedCards.includes(cardId)) {
			dispatch(cardSingleSelect(cardId));
		}
	});
}
